import React from 'react';

const FlameLoader = ({ text = 'Loading...' }) => (
  <div className="flame-loader">
    <div className="flame-wrap">
      <div className="flame-part fp-outer"></div>
      <div className="flame-part fp-mid"></div>
      <div className="flame-part fp-inner"></div>
      <div className="flame-part fp-core"></div>
      <div className="flame-base"></div>
    </div>
    {text && <p className="flame-loader-text">{text}</p>}
  </div>
);

export default FlameLoader;
